import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefGrasslandFertiliser, setBeefGrasslandFertiliserAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_GRASSLAND_FERTILISER } from "consts";

import { FootprintingBeefGrasslandFertiliserPayload } from "models";

export const useMutateFootprintingBeefGrasslandFertiliser = (
  farmId: string,
  year: number,
  payload: FootprintingBeefGrasslandFertiliserPayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_BEEF_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setBeefGrasslandFertiliserAdmin(payload, primaryDataId ?? "") : setBeefGrasslandFertiliser(payload, primaryDataId ?? "")),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_BEEF_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
          ...footprintingBeefPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
